/* eslint-disable */
import $ from 'jquery';
import { style } from '../libs/PrintStyle';
import BaseModule from './BaseModule';

export default class PrintPopup extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'Tab');

    $(el).on('click', '.btn-print-popup', function (e) {
      e.preventDefault();

      const newWindow = window.open('', 'Print-Window');
      const innerPopup = $(el).html();

      newWindow.document.open();
      newWindow.document.write('<html>' + style + '<body onload="window.print()">' + innerPopup + '</body></html>');
      newWindow.document.close();
      setTimeout(() => {
        newWindow.close();
      }, 10);
    })
  }
}
